import { FormattedMessage } from "react-intl";

import { BlackFridayDecoration } from "@components/content-remove-ads/black-friday-decoration";
import CountDown from "@components/countdown/countdown";
import RemoveAdsLink from "@components/remove-ads-link/remove-ads-link";

type DisableAdsBlockProps = {
  isPromotion: boolean;
  isSale: boolean;
  regDatetime: string;
  isBirthday: boolean;
};

function DisableAdsBlock({
  isPromotion,
  isSale,
  regDatetime,
  isBirthday,
}: DisableAdsBlockProps) {
  if (isPromotion) {
    return (
      <div className='dark:bg-purple-dark-light mt-4 rounded-sm bg-black py-4 px-3 text-white md:mt-6 md:px-6'>
        <BlackFridayDecoration smallSize />
        <h4>
          <FormattedMessage id='black-week-discount' />
        </h4>
        <div className='mb-4 text-small-xs md:text-small'>
          <FormattedMessage id='remove-ads-setting-modal' />
        </div>
        <RemoveAdsLink
          id='RemoveAds_btn_tutor_settings'
          additionalClassName='w-full'
          translationID='activate-plus'
        />
      </div>
    );
  }
  if (isBirthday) {
    return (
      <div className='mt-4 rounded-sm bg-indigo py-4 px-3 text-white md:mt-6 md:px-6'>
        <div className='mb-2'>
          <img
            className='mx-auto'
            src='/static/img/birthday/2025/bday.svg'
            alt='birthday'
          />
        </div>
        <h4 className='text-center'>
          <FormattedMessage id='birthday-discount' />
        </h4>
        <div className='mb-3 text-center text-small-xs md:mb-4 md:text-small'>
          <FormattedMessage id='remove-ads-and-get-benefits' />
        </div>
        <RemoveAdsLink
          id='RemoveAds_btn_tutor_settings'
          additionalClassName='w-full'
          translationID='get-discount'
        />
      </div>
    );
  }
  return (
    <div className='dark:bg-purple-dark-light mt-4 rounded-sm bg-purple-light py-4 px-3 text-txt-primary md:mt-6 md:px-6'>
      {isSale && (
        <div className='mb-4 w-fit'>
          <CountDown userRegDateTime={regDatetime} />
        </div>
      )}
      <h4>
        {isSale ? (
          <FormattedMessage id='setting-modal-remove-discounted-ads-title' />
        ) : (
          <FormattedMessage id='remove-ads-setting-modal-title' />
        )}
      </h4>
      <div className='mb-4 text-small-xs md:text-small'>
        {isSale ? (
          <FormattedMessage id='modal-remove-discounted-ads-text' />
        ) : (
          <FormattedMessage id='remove-ads-setting-modal' />
        )}
      </div>
      <RemoveAdsLink
        id='RemoveAds_btn_tutor_settings'
        additionalClassName='w-full'
        translationID={
          window.reactApp.isTrialShow ? "modal-try-trial-btn" : "activate-plus"
        }
      />
    </div>
  );
}

export default DisableAdsBlock;
